import axiosInstance from "../api/axiosInstance";
import { buildAuthHeaders } from "../api/authHeaders";

const unwrapResponse = (response) => response?.data?.data || response?.data || {};
const stripTrailingSlashes = (value = "") => value.replace(/\/+$/, "");

const getCheckoutBaseUrl = () => {
  const configuredBase =
    process.env.REACT_APP_FRONTEND_URL ||
    process.env.REACT_APP_APP_URL ||
    process.env.REACT_APP_BASE_URL ||
    "";

  if (configuredBase) return stripTrailingSlashes(configuredBase);
  if (typeof window !== "undefined" && window.location?.origin) {
    return stripTrailingSlashes(window.location.origin);
  }
  return "";
};

export const subscriptionService = {
  async checkSubscription(jwtToken) {
    const response = await axiosInstance.get("/api/check_stripe_subscription", {
      headers: buildAuthHeaders(jwtToken),
    });
    return unwrapResponse(response);
  },

  async createSubscription(jwtToken, payload) {
    const intervalRaw = payload?.interval;
    const checkoutBaseUrl = getCheckoutBaseUrl();
    const successUrl = `${checkoutBaseUrl}/yearsdashboard?subscription=success`;
    const cancelUrl = `${checkoutBaseUrl}/subscription`;

    const requestPayload = {
      plan_type: payload?.plan_type,
      interval: intervalRaw,
      ...(successUrl ? { success_url: successUrl } : {}),
      ...(cancelUrl ? { cancel_url: cancelUrl } : {}),
    };

    const requestConfig = {
      headers: {
        "Content-Type": "application/json",
        ...buildAuthHeaders(jwtToken),
      },
    };

    const response = await axiosInstance.post(
      "/api/create_stripe_checkout_session",
      requestPayload,
      requestConfig
    );
    const data = unwrapResponse(response);

    if (data?.success === false) {
      const error = new Error(
        data?.message || "Failed to create checkout session."
      );
      error.response = {
        ...response,
        data,
      };
      throw error;
    }

    return data;
  },
};
